import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";

require("./assets/css/Video.css");

const validationSchema = Yup.object({
    name: Yup.string().required('Nome é obrigatório'),
    email: Yup.string().email('Email inválido'),
    phone: Yup.string()
});

const VideoClientEditModal = ({ show, onHide, client, onSave }) => {
    const [loading, setLoading] = useState(false);

    const initialValues = {
        name: client?.name || '',
        email: client?.email || '',
        phone: client?.phone || ''
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            setLoading(true);

            let response;
            if (client?.id) {
                // Atualizar cliente existente
                response = await ApiService.send(
                    "put",
                    `${process.env.REACT_APP_URL_API}video/clients/${client.id}`,
                    values,
                    true
                );
            } else {
                // Criar novo cliente
                response = await ApiService.send(
                    "post",
                    `${process.env.REACT_APP_URL_API}video/clients`,
                    values,
                    true
                );
            }

            if (response.code === 200 || response.code === 201) {
                Swal.fire('Sucesso', client?.id ? 'Cliente atualizado!' : 'Cliente criado!', 'success');
                onSave();
                onHide();
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
            setSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-user me-2"></i>
                    {client?.id ? 'Editar Cliente' : 'Novo Cliente'}
                </Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ errors, touched, isSubmitting }) => (
                    <Form>
                        <Modal.Body>
                            <div className="mb-3">
                                <label className="form-label">Nome *</label>
                                <Field
                                    name="name"
                                    type="text"
                                    className={`form-control ${errors.name && touched.name ? 'is-invalid' : ''}`}
                                    placeholder="Nome completo"
                                />
                                {errors.name && touched.name && (
                                    <div className="invalid-feedback">{errors.name}</div>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">E-mail</label>
                                <Field
                                    name="email"
                                    type="email"
                                    className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                                    placeholder="email@exemplo.com"
                                />
                                {errors.email && touched.email && (
                                    <div className="invalid-feedback">{errors.email}</div>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Telefone</label>
                                <Field
                                    name="phone"
                                    type="text"
                                    className={`form-control ${errors.phone && touched.phone ? 'is-invalid' : ''}`}
                                    placeholder="(00) 00000-0000"
                                />
                                {errors.phone && touched.phone && (
                                    <div className="invalid-feedback">{errors.phone}</div>
                                )}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={onHide}>
                                <i className="fa fa-times me-2"></i>
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-success" disabled={isSubmitting || loading}>
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                ) : (
                                    <i className="fa fa-check me-2"></i>
                                )}
                                {client?.id ? 'Atualizar' : 'Criar'}
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default VideoClientEditModal;
